export const disponibileColfSelezione = {
  disponibileColfSelezionata: "1",
  disponibileColfNonSelezionata: "0"
};